import React from 'react'

const DocumentBody = ()=>null

export default DocumentBody